import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Placeholder, Text } from '@telegram-apps/telegram-ui';

import { Page } from '@/components/Page.tsx';
import { CourseCard } from '@/components/CourseCard';
import { useCoursesStore } from '@/stores/coursesStore';
import { useAppStore } from '@/stores/appStore';
import styles from './CoursesPage.module.css';

export const CoursesPage: FC = () => {
  const { courses } = useCoursesStore();
  const { isLoading, error, entitlements } = useAppStore();
  const navigate = useNavigate();

  if (!isLoading && error) {
    return (
      <Page back={false}>
        <Placeholder description="Ошибка">
          <Text>{error}</Text>
        </Placeholder>
      </Page>
    );
  }

  return (
    <Page back={false}>
      <img
        src="femgym.svg"
        alt="FEMGYM Logo"
        className={isLoading ? styles.logoLoading : styles.logoStatic}
      />
      <div className={isLoading ? styles.coursesListLoading : styles.coursesList}>
        {courses.map((course) => (
          <CourseCard
            key={course.id}
            course={course}
            entitled={entitlements.includes(course.id)}
            onClick={() => {
              void navigate(`/course/${course.id}`);
            }}
          />
        ))}
      </div>
    </Page>
  );
};